import {
  Card,
  CardHeader,
  Col,
  Row,
  Button,
  Input,
  CardBody,
  Collapse,
} from "reactstrap";
import React, { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CollapseButton from "elements/CollapseButton";
import { newToastEvent } from "utils/ToastUtil";

const buttonAddState = {
  title: "Add",
  icon: "mdi-plus",
  class: "btn-outline-secondary",
  open: false,
};

const buttonCloseState = {
  title: "Close",
  icon: "mdi-minus",
  class: "btn-outline-danger",
  open: true,
};

const initialTagInput = {
  val: "",
  saving: false,
};

const TagButton = ({ title }) => (
  <Button size="sm" disabled={true}>
    {title}
  </Button>
);

// For managing a CRM Modules search tags
const ManageModuleTags = ({
  tags,
  currentModule,
  onAdd,
  onUpdate,
  onDelete,
}) => {
  const [buttonState, setButtonState] = useState(buttonAddState);
  const [tagInput, setTagInput] = useState(initialTagInput);
  const [open, setOpen] = useState(true);
  const ReactSwal = withReactContent(Swal);

  // Toggle between the 2 possible states, clear input field each time.
  const toggleState = () => {
    setButtonState((prev) => {
      return prev.open ? buttonAddState : buttonCloseState;
    });
    setTagInput(initialTagInput);
  };

  const inputValidation = (tagName) => {
    if (tagName === "") return "Tags cannot be empty.";

    const newTag = tagName.toLowerCase();

    if (tags && tags.some((tag) => tag.Name === newTag)) {
      return "Tag already exists.";
    }

    return "Passed";
  };

  const addTagToDatabase = () => {
    setTagInput((prev) => ({ ...prev, saving: true }));
    const newTag = tagInput.val.toLowerCase();

    const result = inputValidation(newTag);

    if (result !== "Passed") {
      setTagInput((prev) => ({ ...prev, saving: false }));
      newToastEvent("error", result);
    }

    onAdd(newTag, setTagInput, initialTagInput);
  };

  const startEditingTag = (tag) => {
    ReactSwal.fire({
      title: "Editing Tag",
      html: (
        <>
          Current Tag: <TagButton title={tag.Name} />
        </>
      ),
      input: "text",
      showCancelButton: true,
      confirmButtonText: "Save",
      confirmButtonColor: "#26b058",
      inputValidator: (val) => {
        const validationResponse = inputValidation(val);
        return validationResponse === "Passed" ? false : validationResponse;
      },
    }).then((result) => {
      const { isConfirmed, value } = result;

      if (isConfirmed) onUpdate(tag.id, value);
    });
  };

  const deleteTagFromDatabase = (tag) => {
    ReactSwal.fire({
      title: "Confirm Deletion",
      html: (
        <>
          Are you sure you want to delete <TagButton title={tag.Name} /> ?
        </>
      ),
      icon: "warning",
      confirmButtonText: "Delete",
      confirmButtonColor: "#e72222",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(tag.id);
      }
    });
  };

  return (
    <Card>
      <CardHeader>
        <Row className="align-items-center">
          <Col xs="auto" className="pl-0 pr-0">
            <CollapseButton
              onClick={() => setOpen((prev) => !prev)}
              hidden={open}
            />
          </Col>
          <Col>
            <h6 className="h3 mb-0">{currentModule?.APIName} Record Tags</h6>
          </Col>
          <Col sm={8} className="px-0">
            <div className="d-flex justify-content-end align-items-center">
              {buttonState.open && (
                <>
                  <div style={{ minWidth: 100, width: "100%", maxWidth: 250 }}>
                    <Input
                      style={{ width: "100%", height: 28 }}
                      placeholder="Add tag"
                      value={tagInput.val}
                      onChange={(e) =>
                        setTagInput((prev) => ({
                          ...prev,
                          val: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div style={{ width: 110 }}>
                    <Button
                      size="sm"
                      style={{ marginLeft: 10, marginRight: 20 }}
                      className="btn-outline-success"
                      onClick={() => addTagToDatabase()}
                      disabled={tagInput.saving || tagInput.val === ""}
                    >
                      <span className="btn-inner--icon">
                        <i className={`mdi mdi-plus mr-2`} />
                      </span>
                      <span className="btn-inner--text">Add</span>
                    </Button>
                  </div>
                </>
              )}
              <div style={{ width: 80 }}>
                <Button
                  size="sm"
                  className={buttonState.class}
                  onClick={() => toggleState()}
                >
                  <span className="btn-inner--icon">
                    <i className={`mdi ${buttonState.icon} mr-2`} />
                  </span>
                  <span className="btn-inner--text">{buttonState.title}</span>
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <Collapse isOpen={open}>
        <CardBody className="p-0">
          {tags?.length ? (
            tags.map((tag) => (
              <Row className={`align-items-center`} key={tag.id}>
                <Col className="py-3 pl-5">
                  <TagButton title={tag.Name} />
                </Col>
                <Col xs="auto" className="pr-5 py-3">
                  <Button
                    size="sm"
                    color="secondary"
                    outline
                    onClick={() => startEditingTag(tag)}
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    color="danger"
                    outline
                    onClick={() => deleteTagFromDatabase(tag)}
                  >
                    Delete
                  </Button>
                </Col>
                <Col xs="12">
                  <div className="border-bottom"></div>
                </Col>
              </Row>
            ))
          ) : (
            <h5 className="text-center pt-4 pb-3">You have no tags</h5>
          )}
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default ManageModuleTags;
